import { client } from '../_axios'

/**
 * ログイン
 * @param request
 * @returns
 */
export type AuthRequestType = {
  loginId: string
  password: string
}
export const login = async (request: AuthRequestType) => {
  const API_AUTH = '/auth'

  return await client.post(API_AUTH + '/login', request)
}
